import { render, staticRenderFns } from "./InvitationAdmin.vue?vue&type=template&id=2278d9d4&scoped=true&"
import script from "./InvitationAdmin.vue?vue&type=script&lang=js&"
export * from "./InvitationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278d9d4",
  null
  
)

export default component.exports